import React from 'react';
import { identifiableName } from '@/utils/resultsHelper';
import ToastMessage from './ToastMessage';
import DeletedToast from './DeletedToast';
import NegativeToast from './NegativeToast';

const DeletesToast = ({ items }) => {
  if (items.length === 1) {
    return (<DeletedToast name={identifiableName(items)} />);
  }

  return (
    <NegativeToast className="aridhia-deletes-toast">
      <ToastMessage items={items} multiple="toast.deletes" />
    </NegativeToast>
  );
};

export default DeletesToast;
